import { render, staticRenderFns } from "./PurchaseOrderCard.vue?vue&type=template&id=10abad6b&scoped=true"
import script from "./PurchaseOrderCard.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderCard.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrderCard.vue?vue&type=style&index=0&id=10abad6b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10abad6b",
  null
  
)

export default component.exports